import '../scss/front.scss'

import { BurgerButtonToggle, OffcanvasClickAway, ScrollMobileMenu } from './components/menu'
import { OffCanvas } from './components/offCanvas'
import { OffcanvasSearchClickAway } from './components/search'

window.addEventListener('DOMContentLoaded', () => {
  OffcanvasClickAway()
  ScrollMobileMenu()
  OffCanvas()
  BurgerButtonToggle()

  OffcanvasSearchClickAway()
})
